import Constants from 'expo-constants'
import { Dimensions, StatusBar } from 'react-native'
import theme from '../../../theme'

const styles = {
    // Posts
    headerPost: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 10,
        marginBottom: 10,
    },
    leftHeaderPostDetail: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        minWidth: 80,
        flexShrink: 0,
    },
    datePost: {
        flexDirection: 'row',
        fontSize: 12,
        textAlign: 'right',
    },
    viewsPost: {
        flexDirection: 'row',
        fontSize: 11,
        textAlign: 'right',
        color: theme.colors.textSecondary,
    },
    avatarModulePost: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        marginRight: 8,
    },
    nameAvatarNamePost: {
        marginLeft: 8,
        flex: 1,
        maxWidth: '100%',
    },

    image: {
        width: 30,
        height: 30,
        borderRadius: 15,
        overflow: 'hidden',
        transform: [{ scale: 1.0 }],
        //imageAlign: 'center',
    },
    imagePost: {
        width: '100%',
        aspectRatio: 1,
        marginTop: 10,
        //imageAlign: 'fit',
    },
}

export default styles
